import { useQuery } from "react-query";
import middlewareAPI from "../services/middleware";

const useSearchListings = (inputData: any) => {
  const { isFetched, isFetching, data, error, refetch, isLoading } = useQuery(
    ["searchListings", inputData],
    async () => {
      if (inputData?.city) {
        const { data } = await middlewareAPI.post(
          "listings/v2/search/limitedData",
          inputData
        );
        return data;
      } else {
        return null;
      }
    },
    {
      enabled: false,
      staleTime: 300000,
      cacheTime: 300000,
    }
  );
  return {
    isFetched,
    isFetching,
    isLoading,
    data,
    error,
    refetch,
  };
};

export default useSearchListings;
